import { render, staticRenderFns } from "./AssignHabitComboDialog.vue?vue&type=template&id=f4a4bdea&scoped=true"
import script from "./AssignHabitComboDialog.vue?vue&type=script&lang=js"
export * from "./AssignHabitComboDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignHabitComboDialog.vue?vue&type=style&index=0&id=f4a4bdea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a4bdea",
  null
  
)

export default component.exports